<div class="card">
	<div class="card-header bg-transparent border-0 pt-3 pt-md-4 px-3 px-md-4 pb-0">
		<h5 class="mb-0 fw-semibold">{{ title() }}</h5>
	</div>

	<div class="card-body px-3 px-md-4 pt-2 pt-md-3 pb-3 pb-md-4">
		@if (isLoading()) {
			<div class="d-flex align-items-center justify-content-center" [style.height.px]="effectiveHeight()">
				<div class="spinner-border spinner-border-sm text-muted" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>
		} @else {
			<div class="chart-canvas-wrapper" [style.height.px]="effectiveHeight()">
				<canvas #canvasRef role="img" [attr.aria-label]="title()"></canvas>
			</div>
		}
	</div>
</div>
